package com.partejar.app.feature.gestantes.data

interface GestantesDataSource {
    suspend fun loadPage(
        page: Int,
        size: Int,
        name: String?,
        statuses: Set<GestanteListStage>
    ): GestantesPageData
}

interface GestanteClinicalDataSource {
    suspend fun detail(id: Long): GestanteClinicalDetail
    suspend fun update(id: Long, update: GestanteClinicalUpdate): GestanteClinicalDetail
    suspend fun registerDelivery(id: Long, input: GestanteDeliveryInput): GestanteClinicalDetail
    suspend fun addComorbidity(id: Long, description: String, observation: String?): GestanteComorbidity
    suspend fun updateComorbidity(id: Long, comorbidityId: Long, observation: String?): GestanteComorbidity
    suspend fun deactivateComorbidity(id: Long, comorbidityId: Long): GestanteComorbidity
    suspend fun examTypes(): List<GestanteExamType>
    suspend fun examCatalog(): List<GestanteExamType> = examTypes()
    suspend fun exams(id: Long): List<GestanteExam>
    suspend fun createExam(id: Long, input: GestanteExamInput): GestanteExam
    suspend fun addExamResult(id: Long, examId: Long, input: GestanteExamResultInput): GestanteExam
    suspend fun updateExamResult(id: Long, examId: Long, resultId: Long, input: GestanteExamResultInput): GestanteExam
}
